module.exports = __webpack_public_path__ + "img/A3-3-plan.41c544ce.png";